import { SVGProps } from 'react';

export const AccessDenied = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="300"
    height="300"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.32"
      x="28.4229"
      y="27.4316"
      width="244.567"
      height="244.567"
      rx="122.284"
      fill="#E5E5E5"
    />
    <path
      d="M261.061 88.0723L261.061 219.304C261.06 222.598 258.39 225.268 255.096 225.269L64.2139 225.269C60.9195 225.269 58.2491 222.598 58.249 219.304L58.249 88.0723C58.2492 84.778 60.9195 82.1074 64.2139 82.1074L255.096 82.1074C258.39 82.1076 261.06 84.7781 261.061 88.0723Z"
      fill="#F2F3F4"
      stroke="#666666"
      strokeWidth="1.98835"
    />
    <path
      d="M252.112 88.0723L252.112 219.304C252.112 222.598 249.442 225.268 246.147 225.269L55.2656 225.269C51.9712 225.269 49.3008 222.598 49.3008 219.304L49.3008 88.0723C49.3009 84.778 51.9713 82.1074 55.2656 82.1074L246.147 82.1074C249.442 82.1076 252.112 84.7781 252.112 88.0723Z"
      fill="white"
      stroke="#666666"
      strokeWidth="1.98835"
    />
    <path
      d="M252.112 88.0762L252.112 92.0527C252.112 95.3471 249.442 98.0184 246.147 98.0186L55.2656 98.0185C51.9712 98.0185 49.3008 95.3471 49.3008 92.0527L49.3008 88.0762C49.3009 84.7819 51.9713 82.1113 55.2656 82.1113L246.147 82.1113C249.442 82.1115 252.112 84.782 252.112 88.0762Z"
      fill="#E5E5E5"
      stroke="#666666"
      strokeWidth="1.98835"
    />
    <path
      d="M75.4053 90.0664C75.4053 91.8543 73.9559 93.3036 72.168 93.3037L64.2148 93.3037C62.4269 93.3037 60.9766 91.8544 60.9766 90.0664C60.9766 88.2785 62.4269 86.8291 64.2148 86.8291L72.168 86.8291C73.9558 86.8292 75.4052 88.2785 75.4053 90.0664Z"
      fill="#F2F3F4"
      stroke="#666666"
      strokeWidth="1.47852"
    />
    <path
      d="M96.2832 90.0664C96.2832 91.8543 94.8338 93.3036 93.0459 93.3037L85.0928 93.3037C83.3048 93.3037 81.8545 91.8544 81.8545 90.0664C81.8546 88.2785 83.3048 86.8291 85.0928 86.8291L93.0459 86.8291C94.8338 86.8292 96.2831 88.2785 96.2832 90.0664Z"
      fill="#F2F3F4"
      stroke="#666666"
      strokeWidth="1.47852"
    />
    <path
      d="M117.16 90.0664C117.16 91.8543 115.711 93.3036 113.923 93.3037L105.97 93.3037C104.182 93.3037 102.731 91.8544 102.731 90.0664C102.732 88.2785 104.182 86.8291 105.97 86.8291L113.923 86.8291C115.711 86.8292 117.16 88.2785 117.16 90.0664Z"
      fill="#F2F3F4"
      stroke="#666666"
      strokeWidth="1.47852"
    />
    <circle
      cx="114.918"
      cy="144.744"
      r="23.8602"
      fill="white"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
    />
    <circle
      cx="114.917"
      cy="144.745"
      r="15.9068"
      fill="#E5E5E5"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
    />
    <circle
      cx="186.498"
      cy="144.744"
      r="23.8602"
      fill="white"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
    />
    <path
      d="M138.777 141.762L143.06 139.977C147.954 137.938 153.461 137.938 158.355 139.977L162.638 141.762"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
      strokeLinecap="round"
    />
    <path
      d="M138.777 184.512H150.707H162.638"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
      strokeLinecap="round"
    />
    <rect
      x="202.404"
      y="43.2832"
      width="84.7948"
      height="84.7948"
      rx="42.3974"
      fill="#DFDFDF"
    />
    <rect
      x="207.13"
      y="39.4054"
      width="82.7185"
      height="82.7185"
      rx="41.3592"
      fill="white"
      stroke="#666666"
      strokeWidth="2.07639"
    />
    <path
      d="M254.778 54.6914L254.778 81.251C254.778 84.2723 252.329 86.7217 249.308 86.7217L248.555 86.7217C245.533 86.7216 243.084 84.2723 243.084 81.251L243.084 54.6914C243.084 51.6701 245.533 49.2208 248.555 49.2207L249.308 49.2207C252.329 49.2207 254.778 51.6701 254.778 54.6914Z"
      fill="#E5E5E5"
      stroke="#666666"
      strokeWidth="1.82354"
    />
    <path
      d="M254.619 98.457C254.619 101.478 252.17 103.928 249.148 103.928C246.127 103.928 243.678 101.478 243.678 98.457C243.678 95.4358 246.127 92.9865 249.148 92.9863C252.17 92.9863 254.619 95.4357 254.619 98.457Z"
      fill="#E5E5E5"
      stroke="#666666"
      strokeWidth="1.82354"
    />
    <circle
      cx="186.497"
      cy="144.745"
      r="15.9068"
      fill="#E5E5E5"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
    />
    <path
      d="M209.363 134.306H251.616"
      stroke="#8C8C8C"
      strokeWidth="1.98835"
      strokeLinecap="round"
    />
  </svg>
);
